export const isValidEmail = (email: string) => /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(email);
export const createLengthValidator = (minLength: number) => (value: string) => value.length > minLength;
export const isNotBlank = (text?: string | null) => (text ?? '').trim().length > 0;
